import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "ux-patterns"
    }}>{`UX patterns`}</h1>
    <p>{`The UX patterns section includes requirements and best practices to ensure that your plugin follows Adobe user experience patterns.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Designingforphotoshop/"
        }}>{`Designing for Photoshop`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "branding/"
        }}>{`Branding`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "messaging/"
        }}>{`Messaging`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "onboarding/"
        }}>{`Onboarding`}</a></li>
    </ul>
    <h2 {...{
      "id": "ux-requirements"
    }}>{`UX requirements`}</h2>
    <p>{`UX requirements highlight key patterns that all plugins need to follow in order to get approved by Adobe.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "83.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/cb523/plugindialogspecs.webp 320w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/797b9/plugindialogspecs.webp 640w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/4b075/plugindialogspecs.webp 1280w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/f3ff0/plugindialogspecs.webp 1920w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/be156/plugindialogspecs.webp 2430w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/72799/plugindialogspecs.png 320w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/6af66/plugindialogspecs.png 640w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/21b4d/plugindialogspecs.png 1280w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/29114/plugindialogspecs.png 1920w", "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/6cb28/plugindialogspecs.png 2430w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/4d99bbc94c951e9dfb006db0ceccebc0/21b4d/plugindialogspecs.png",
            "alt": "An example showing the UX requirements for a plugin dialog",
            "title": "An example showing the UX requirements for a plugin dialog",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "ux-best-practices"
    }}>{`UX best practices`}</h2>
    <p>{`Best practices provide recommendations on plugin usability and behavior, user feedback, privacy, and interface guidelines.
These use “do” and “don’t” examples to illustrate the recommendations.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "19.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/cb523/psicondosdonts.webp 320w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/797b9/psicondosdonts.webp 640w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/4b075/psicondosdonts.webp 1280w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/f3ff0/psicondosdonts.webp 1920w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/09431/psicondosdonts.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/72799/psicondosdonts.png 320w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/6af66/psicondosdonts.png 640w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/21b4d/psicondosdonts.png 1280w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/29114/psicondosdonts.png 1920w", "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/20a65/psicondosdonts.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/b10afb45779ab23edb3b8edccd6bee65/21b4d/psicondosdonts.png",
            "alt": "An example showing the UX best practices for icons in Photoshop",
            "title": "An example showing the UX best practices for icons in Photoshop",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      